import { makeStyles } from "tss-react/mui"
import { Box, ButtonBase, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    toggleContainer: {
        display: "flex",
        borderRadius: "1.75rem",
        overflow: "hidden",
        backgroundColor: "#f1f5f9",
    },
    toggleButton: {
        borderRadius: "1.5rem",
        padding: "0.1rem 1rem",
        width: "50%",
        transition: "background-color 0.3s ease",
        "&.selected": {
            backgroundColor: "#93C5FD",
            color: "#000",
        },
        "&.unselected": {
            backgroundColor: "transparent",
            color: "#64748b",
        },
    },
    buttonText: {
        fontWeight: 500,
    },
}))

type UserToggleProps = {
    value: string
    onChange: (selected: "single" | "group") => void
}

export function UserToggle({ value, onChange }: UserToggleProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.toggleContainer}>
            <ButtonBase
                key={"single"}
                className={`${classes.toggleButton} ${value === "single" ? "selected" : "unselected"}`}
                onClick={() => onChange("single")}
            >
                <LocalizedStrict id="service-center-reports-check-in-modal-single">
                    <Typography className={classes.buttonText}>Single</Typography>
                </LocalizedStrict>
            </ButtonBase>
            <ButtonBase
                key={"group"}
                className={`${classes.toggleButton} ${value === "group" ? "selected" : "unselected"}`}
                onClick={() => onChange("group")}
            >
                <LocalizedStrict id="service-center-reports-check-in-modal-group">
                    <Typography className={classes.buttonText}>Group</Typography>
                </LocalizedStrict>
            </ButtonBase>
        </Box>
    )
}
